export const ACCORDION_UPDATE_ERP_KEY = "ACCORDION_UPDATE_ERP_KEY";
export const ACCORDION_UPDATE_DATE = "ACCORDION_UPDATE_DATE";
export const ACCORDION_UPDATE_DATE_LAST_UPDATE = "ACCORDION_UPDATE_DATE_LAST_UPDATE";
export const ACCORDION_UPDATE_DESCRIPTION = "ACCORDION_UPDATE_DESCRIPTION";
export const ACCORDION_UPDATE_COST = "ACCORDION_UPDATE_COST";
export const ACCORDION_UPDATE_DEFAULT = "ACCORDION_UPDATE_DEFAULT";
export const ACCORDION_SUBMIT_FORM_DATA = "ACCORDION_SUBMIT_FORM_DATA";
export const ACCORDION_SUBMIT_FORM_DATA_SUCCESS = "ACCORDION_SUBMIT_FORM_DATA_SUCCESS";
export const ACCORDION_CANCEL_UPDATE = "ACCORDION_CANCEL_UPDATE";
export const ACCORDION_INSERT_UPDATED_ROW = "ACCORDION_INSERT_UPDATED_ROW";